import { getServiceUrl } from '../api';
import RequestService from '../httpRequest';

export default {
    // 获取音色
    getVoiceList(params, callback) {
        const queryParams = new URLSearchParams({
            ttsModelId: params.ttsModelId,
            page: params.page || 1,
            limit: params.limit || 10,
            name: params.name || ''
        }).toString();

        RequestService.sendRequest()
            .url(`${getServiceUrl()}/ttsVoice?${queryParams}`)
            .method('GET')
            .success((res) => {
                RequestService.clearRequestTime();
                callback(res.data || []);
            })
            .networkFail((err) => {
                console.error('获取音色列表失败:', err);
                RequestService.reAjaxFun(() => {
                    this.getVoiceList(params, callback);
                });
            }).send();
    },
    // 音色保存
    saveVoice(params, callback) {
        RequestService.sendRequest()
            .url(`${getServiceUrl()}/ttsVoice`)
            .method('POST')
            .data(JSON.stringify({
                name: params.voiceName,
                remark: params.remark,
                referenceAudio: params.referenceAudio,
                referenceText: params.referenceText,
                sort: params.sort,
                ttsModelId: params.ttsModelId,
                ttsVoice: params.voiceCode,
                voiceDemo: params.voiceDemo || '',
                isPublic: params.isPublic,
                owner: params.owner
            }))
            .success((res) => {
                callback(res.data);
            })
            .networkFail((err) => {
                console.error('保存音色失败:', err);
                RequestService.reAjaxFun(() => {
                    this.saveVoice(params, callback);
                });
            }).send();
    },
    // 音色删除
    deleteVoice(ids, callback) {
        RequestService.sendRequest()
            .url(`${getServiceUrl()}/ttsVoice/delete`)
            .method('POST')
            .data(ids)
            .success((res) => {
                RequestService.clearRequestTime()
                callback(res);
            })
            .networkFail((err) => {
                console.error('删除音色失败:', err);
                RequestService.reAjaxFun(() => {
                    this.deleteVoice(ids, callback);
                });
            }).send();
    },
    // 复制音色
    copyVoice(sourceId, callback) {
        RequestService.sendRequest()
            .url(`${getServiceUrl()}/ttsVoice/copy`)
            .method('POST')
            .data(JSON.stringify({ sourceId }))
            .success((res) => {
                callback(res.data || res);
            })
            .networkFail((err) => {
                console.error('复制音色失败:', err);
                RequestService.reAjaxFun(() => {
                    this.copyVoice(sourceId, callback);
                });
            }).send();
    },
    // 音色修改
    updateVoice(params, callback) {
        RequestService.sendRequest()
            .url(`${getServiceUrl()}/ttsVoice/${params.id}`)
            .method('PUT')
            .data(JSON.stringify({
                name: params.voiceName,
                remark: params.remark,
                referenceAudio: params.referenceAudio,
                referenceText: params.referenceText,
                ttsModelId: params.ttsModelId,
                ttsVoice: params.voiceCode,
                voiceDemo: params.voiceDemo || '',
                isPublic: params.isPublic,
                owner: params.owner
            }))
            .success((res) => {
                callback(res.data);
            })
            .networkFail((err) => {
                console.error('修改音色失败:', err);
                RequestService.reAjaxFun(() => {
                    this.updateVoice(params, callback);
                });
            }).send();
    },
    // 音色试听：请求试听音频流，success 回调接收 blob
    getPreviewVoice(voiceId, successCallback, failCallback) {
        RequestService.sendRequest()
            .url(`${getServiceUrl()}/ttsVoice/preview?voiceId=${encodeURIComponent(voiceId)}`)
            .method('GET')
            .type('blob')
            .success((res) => {
                if (res.data && successCallback) successCallback(res.data);
            })
            .networkFail((err) => {
                console.error('试听请求失败:', err);
                if (failCallback) failCallback(err);
            })
            .fail((res) => {
                if (failCallback) failCallback(res);
            })
            .send();
    }
}